import React from "react";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {EntityLogo, EntityLogoProps} from "../../../../core/components/logos/entity-logo";
import type {LineupsMemberViewModel} from "../../../../domain/yard/lineups/lineups-member/lineups-member-view-model";
import {Ellipsis} from "../../../../core/components/misc/ellipsis/ellipsis";
import {BoxScoresWidgetController} from "../../box-scores-widget.controller";
import {Link} from "../../../../core/components/link/link";
import {LINEUPS} from "../../../lineups-widget/lineups-widget.consts";
import {observer} from "mobx-react";
import classnames from "classnames";
import styles from "../../styles/box-scores-widget.module.scss";

class BoxScoresWidgetRowPrimaryCellsMemberProps extends BaseProps {
  member: LineupsMemberViewModel;
  selectedAthleteId: Number;
  shouldRenderEntityImage: Boolean;
  isPlayerCardPopupVisible: Boolean;
  shouldPlayerClickable: Boolean;
  controller: BoxScoresWidgetController;
}

export const BoxScoresWidgetRowPrimaryCellsMember = observer((({member, controller}: BoxScoresWidgetRowPrimaryCellsMemberProps) => {
  const {state, device: {isSmallView}} = controller;
  const {shouldPlayerClickable, shouldRenderEntityImage} = state;
  const memberName = member?.shortName ? member.shortName : member.name;
  const positionName = member.formation?.name || member.position?.name;
  const fouledOutTitle = controller.terms.WEB_BOX_SCORE_FOULED_OUT_INDICATION;

  const subTitleMemberLabel = member.fouledOut ? fouledOutTitle : positionName

  const logoProps: EntityLogoProps = {
    className: classnames(styles.row_primary_cells_member_logo),
    entity: member,
    width: isSmallView ? 36 : 40,
    height: isSmallView ? 36 : 40,
  }

  const memberNameProps = {
    text: memberName,
    numOfMaxLines: 1,
    className: classnames(styles.row_primary_cells_member_name)
  }

  const isClickable = member.linkModel || shouldPlayerClickable;

  const linkProps = {
    className: classnames(styles.row_primary_cells_row_container, {[styles.row_primary_cells_row_no_images_container]: !shouldRenderEntityImage, [styles.clickable]: isClickable }),
    model: member.linkModel,
    onClick: () => {
      shouldPlayerClickable && controller.action(LINEUPS.ACTION_TYPES.onPlayerCardPopupClick, {
        selectedAthleteId: member.athleteId,
        isVisible: true
      })

      return !shouldPlayerClickable;
    }
  }

  return (
    <Link {...linkProps}>
      {
        shouldRenderEntityImage && <EntityLogo {...logoProps}/>
      }
      <div className={classnames(styles.row_primary_cells_member_name_container)}>
        <Ellipsis {...memberNameProps}/>
        <div className={classnames(styles.row_primary_cells_member_sub_title, {[styles.row_primary_cells_member_sub_title_fouled_out]: member.fouledOut})}>{subTitleMemberLabel}</div>
      </div>
    </Link>
  )
}));
